"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
mutation deleteEventOrSeasonFee($eventId: String, $seasonId: String, $feeId: String!, $orgId: String) {
  deleteEventOrSeasonFee(eventId: $eventId, seasonId: $seasonId, feeId: $feeId, orgId:$orgId)
}
`;
exports.default = mutation;
//# sourceMappingURL=deleteEventOrSeasonFee.mutation.js.map